"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Hyperlink = _interopRequireDefault(require("./Hyperlink"));

var _WithExternalLinkIcon = _interopRequireDefault(require("./WithExternalLinkIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = {
  "default": _Hyperlink["default"],
  WithExternalLinkIcon: _WithExternalLinkIcon["default"]
};
exports["default"] = _default;